// Enum: lime.graphics.ImageFileFormat

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../estr_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Definition

var ImageFileFormat = $hxEnums["lime.graphics.ImageFileFormat"] = { __ename__ : "lime.graphics.ImageFileFormat", __constructs__ : ["BMP","JPEG","PNG"]
  ,PNG: {_hx_index:2,__enum__:"lime.graphics.ImageFileFormat",toString:$estr}
  ,JPEG: {_hx_index:1,__enum__:"lime.graphics.ImageFileFormat",toString:$estr}
  ,BMP: {_hx_index:0,__enum__:"lime.graphics.ImageFileFormat",toString:$estr}
};

exports.default = ImageFileFormat;